
/*
 * Copyright (C) 2015 ICOS Group, Newcastle University.  All rights reserved.
 * Contact:  James Alastair McLaughlin <j.a.mclaughlin@ncl.ac.uk>
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions
 * are met:
 *  
 * 1. Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  
 * 2. Redistributions in binary form must reproduce the above copyright
 *    notice, this list of conditions and the following disclaimer in the
 *    documentation and/or other materials provided with the distribution.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE AUTHOR AND CONTRIBUTORS ``AS IS'' AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
 * OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
 * SUCH DAMAGE.
 */

"use strict";

var xml = require('xml'),
    serializeAnnotation = require('./serializeAnnotation');

module.exports = function serializeIdentified(sbolDocument, xmlAttribsRef, identified, tagName, properties) {

    var tags = [
        { _attr: { 'rdf:about': identified.uri }}
    ];

    if(identified.persistentIdentity.toString() !== '') {
        tags.push({ 'sbol:persistentIdentity': { _attr: { 'rdf:resource': identified.persistentIdentity }}});
    }

    if(identified.displayId.toString() !== '')
        tags.push({ 'sbol:displayId': identified.displayId });

    if(identified.version.toString() !== '')
        tags.push({ 'sbol:version': identified.version });

    if(identified.wasDerivedFrom.toString() !== '')
        tags.push({ 'prov:wasDerivedFrom': { _attr: { 'rdf:resource': identified.wasDerivedFrom }}});

    if(identified.wasGeneratedBy.toString() !== '')
        tags.push({ 'prov:wasGeneratedBy': { _attr: { 'rdf:resource': identified.wasGeneratedBy }}});

    if(identified.name.toString() !== '')
        tags.push({ 'dcterms:title': identified.name });

    if(identified.description.toString() !== '')
        tags.push({ 'dcterms:description': identified.description });

	identified.attachments.forEach(function(attachment) {
		tags.push({ 'sbol:attachment': { _attr: { 'rdf:resource': attachment.uri }}});
	});

    identified.annotations.forEach(function(annotation) {
        tags.push(serializeAnnotation(sbolDocument, xmlAttribsRef, annotation));
    });

    return {
        [tagName]: tags.concat(properties)
    };
}
